<div class="side-nav">

  <mat-toolbar color="primary" class="side-nav__toolbar">

    <div class="side-nav__top-menu">

      <div class="side-nav__top-menu-button">

        <button class="side-nav__toggle-button" mat-icon-button (click)="snav.toggle()">

          <mat-icon>menu</mat-icon>

        </button>

      </div>

      <div class="side-nav__title-container">

        <div class="side-nav__banner--title">

          <h3 class="side-nav__app-name">💬 {{ title() }}</h3>

        </div>
        
        <div class="side-nav__banner--user-info">

          <span class="side-nav__user-name">{{ userName }}</span>
          
          <mat-icon class="side-nav__banner--user-info__lock" aria-hidden="false" (click)="logout()" aria-label="Example lock icon" fontIcon="lock"></mat-icon>
       
        </div>

      </div>

    </div>

  </mat-toolbar>

  <mat-sidenav-container class="side-nav__sidenav-container">

    <mat-sidenav [opened]="!isMobile()" #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      
      <div class="side-nav__menu-items">

        <div class="side-nav__menu-items__search" >
          <input 
            type="search"
            (input)='FilterMenuItems($event)'  
            class="input_nosubmit_white side_nav-search_input"
            placeholder="Buscar item"
          >
        </div>
        
        <mat-nav-list>
          
          <div class="side-nav__menu-items__menu-container">

            @for (item of menuItems(); track item.name) {
            
            <div>
              
              @if (isMobile()) {
                
                <div
                  class="side-nav__menu-item"
                  tabindex="0"
                  (click)="item.subItems?.length ? toggleSubMenu(item.name) : snav.toggle()"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && (item.subItems?.length ? toggleSubMenu(item.name) : snav.toggle())"
                >
                 
                  <a mat-list-item [routerLink]="item.route">{{ item.name }}</a>
                  
                  @if (item.subItems?.length) {
                  
                    <button mat-icon-button (click)="$event.stopPropagation(); toggleSubMenu(item.name)">
                    
                      <mat-icon>
                        {{ openedItems.has(item.name) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                   
                    </button>
                  
                  }
                
                </div>
               
                @if (item.subItems?.length && openedItems.has(item.name)) {
                  
                  <div class="side-nav__submenu">
                  
                    @for (subItem of item.subItems; track subItem.name) {
                     
                      <div
                        class="side-nav__menu-item"
                        tabindex="0"
                        (click)="isMobile() ? snav.toggle() : null; $event.stopPropagation()"
                        (keydown)="($event.key === 'Enter' || $event.key === ' ') && (item.subItems?.length ? toggleSubMenu(item.name) : snav.toggle())"
                      >
                     
                        <a mat-list-item [routerLink]="subItem.route">{{ subItem.name }}</a>
                     
                      </div>
                   
                    }
                  
                  </div>
                
                }
              
              } @else {
               
                <div
                  class="side-nav__menu-item"
                  tabindex="0"
                  (click)="item.subItems?.length ? toggleSubMenu(item.name) : null"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && item.subItems?.length ? toggleSubMenu(item.name) : null"
                >
               
                  <a mat-list-item [routerLink]="item.route">{{ item.name }}</a>
                
                  @if (item.subItems?.length) {
                
                    <button mat-icon-button (click)="$event.stopPropagation(); toggleSubMenu(item.name)">
                 
                      <mat-icon>
                 
                        {{ openedItems.has(item.name) ? 'expand_less' : 'expand_more' }}
                 
                      </mat-icon>
                 
                    </button>
                 
                  }
                
                </div>
               
                @if (item.subItems?.length && openedItems.has(item.name)) {
               
                  <div class="side-nav__submenu">
               
                    @for (subItem of item.subItems; track subItem.name) {
               
                      <div class="side-nav__menu-item side-nav__menu-item--sub">
               
                        <a mat-list-item [routerLink]="subItem.route">{{ subItem.name }}</a>
               
                      </div>
                
                    }
                  </div>
                }
              }

            </div>

          }
          
          </div>
          
        </mat-nav-list>

      </div>

    </mat-sidenav>

    <mat-sidenav-content class="side-nav__content">

      <div class="side-nav__router-outlet-main">

        <div class="side-nav__router-outlet">

          <router-outlet></router-outlet>

        </div>

      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>